<template>
  <div>
    <b-modal
      v-model="skModal"
      size="xl"
      centered
      modal-class="modal-sk"
      header-class="modal-header-sk"
      body-class="modal-body-sk"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="text-center w-100 handle-title-data">
        SYARAT & KETENTUAN TELAH DIPERBAHARUI PADA TANGGAL
        {{ updatedDate.toUpperCase() }} (VERSI {{ TNCVersion }})
      </div>
      <div class="terms-conditions-scroll handle-pure-scroll">
        <img
          v-for="(image, i) in documentPure"
          :key="i"
          :src="image"
          alt=""
          width="100%"
        >
      </div>

      <b-form-checkbox
        v-model="checkSK"
        button-variant="success"
        class="mt-3 font-weight-bold"
      >
        Saya telah membaca dan setuju dengan syarat & ketentuan yang berlaku
      </b-form-checkbox>
      <div class="text-center">
        <b-button
          variant="success-acc"
          class="mt-3"
          :disabled="!checkSK || loading"
          @click="openGuideModal"
        >
          <span v-if="!loading"> SETUJU </span>
          <Loader
            v-if="loading"
            :style-loading="'#fff'"
            :opacity="'1'"
            :circle-color="'#33B430'"
          />
        </b-button>
      </div>
    </b-modal>
    <div v-if="viewTutorial" class="modal-tutorial">
      <div style="max-width: 900px" class="p-4 modal-tutorial-center">
        <div class="card mt-4 p-4">
          <vue-plyr>
            <video
              src="https://yesdok.com/assets/videos/cara-penggunaan-panel-dokter-spesialis-yesdok-v3.mp4"
            />
          </vue-plyr>
          <h4 class="font-rubik-medium mt-3 mb-4">
            Cara Penggunaan Panel Dokter Spesialis YesDok
          </h4>
          <div class="d-flex justify-content-end">
            <b-button
              class="mr-3 px-3"
              variant="green"
              @click="goBack"
            >
              <img
                src="@/assets/img/icon-back.png"
                width="16px"
                class="mr-2"
                style="margin-top: -3px"
              >Kembali
            </b-button>
            <b-button
              variant="red"
              class="px-4"
              @click="closeTutorial"
            >
              <font-awesome-icon
                class="mr-2"
                icon="times-circle"
              />Tutup
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="guideModal" class="modal-panduan">
      <div class="p-4 modal-panduan-center">
        <div class="card mt-4 p-4">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-md-4">
                <div class="cursor-pointer" @click="openViewTutorial">
                  <div class="image-thumbnail">
                    <img
                      src="@/assets/img/icon-play.png"
                      alt=""
                      class="image-center"
                      width="45px"
                    >
                    <img
                      src="@/assets/img/thumbnail-video.png"
                      width="100%"
                      class="shadow-img"
                      alt=""
                    >
                  </div>
                  <h6 class="font-weight-bold mt-3">
                    Cara Penggunaan Panel Dokter Spesialis YesDok
                  </h6>
                </div>
              </div>
            </div>
            <div v-if="$store.state.user.auth.role !== 'admin'" class="row">
              <div class="col-12">
                <div
                  class="bg-grey my-4 py-3 px-4 mx-n4 d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center">
                    <img src="@/assets/img/icon-pdf.png" alt="">
                    <h4 class="font-rubik-medium mb-0 ml-3 mr-4">
                      Syarat & Ketentuan
                    </h4>
                    <span v-if="TNCVersion">Versi {{ TNCVersion }}</span>
                  </div>
                  <b-button
                    variant="green"
                    class="btn-sk"
                    @click="goToSK"
                  >
                    Lihat Syarat & Ketentuan
                  </b-button>
                </div>
              </div>
            </div>
            <div v-else class="row mt-5" />
            <div class="row">
              <div class="col-12">
                <h5 class="font-rubik-medium">
                  Punya pertanyaan atau masalah?
                </h5>
                <div class="d-flex justify-content-between">
                  <b-button
                    variant="green"
                    href="mailto:dok@yesdok.com"
                    target="_blank"
                  >
                    Hubungi Kami
                  </b-button>
                  <b-button
                    variant="red"
                    class="px-4"
                    @click="closeTutorial"
                  >
                    <font-awesome-icon
                      class="mr-2"
                      icon="times-circle"
                    />Tutup
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="skDetailModal" class="modal-panduan">
      <div class="p-4 modal-panduan-center">
        <div class="card mt-4 p-4">
          <div
            class="terms-conditions-scroll"
            style="height: 80vh; max-height: 80vh"
          >
            <div
              class="terms-conditions-scroll"
              style="height: 80vh; overflow: scroll"
            >
              <img
                v-for="(image, i) in documentPure"
                :key="i"
                :src="image"
                alt=""
                width="100%"
              >
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-3">
            <h5 class="font-rubik-medium mb-0">
              Syarat & Ketentuan
              <span
                class="ml-3 font-18px font-rubik-regular"
              >Versi {{ TNCVersion }}</span>
            </h5>
            <div>
              <b-button
                class="mr-3 px-3"
                variant="green"
                @click="goBack"
              >
                <img
                  src="@/assets/img/icon-back.png"
                  width="16px"
                  class="mr-2"
                  style="margin-top: -3px"
                >Kembali
              </b-button>
              <b-button
                variant="red"
                class="px-4"
                @click="closeTutorial"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="times-circle"
                />Tutup
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/LoaderButton.vue'
export default {
  name: 'Tutorial',
  components: {
    Loader
  },
  data: () => ({
    document: '',
    documentPure: '',
    endDuration: false,
    skModal: false,
    skDetailModal: false,
    viewTutorial: false,
    checkSK: false,
    userId: null,
    TNCVersion: null,
    TNCPath: null,
    doctorType: null,
    updatedDate: '',
    loading: false
  }),
  computed: {
    guideModal: {
      get () {
        return this.$store.state.guideModal
      },
      set (value) {
        this.$store.commit('SET_OPEN_GUIDE_MODAL', value)
      }
    }
  },
  mounted () {
    this.checkHasViewTutorial()
  },
  methods: {
    checkHasViewTutorial () {
      const res = this.$store.state.user.auth.userData
      // if user id not exist, don't show tutorial
      if (!res.ID) {
        return
      }

      this.userId = res.ID
      this.doctorType = res.DoctorType
      if (res.ClinicEmployeeType && res.ClinicEmployeeType !== 'SELF' && !res.TNCFilename) {
        this.handlingTncByEmployeeType(res.ClinicEmployeeType)
        setTimeout(() => {
          this.skModal = true
        }, 1)
      } else if (!res.TNCFilename) {
        this.skModal = true
        this.TNCVersion = res.TNCVersion
        this.getPureDocument()
      } else {
        this.skModal = false
        this.TNCVersion = res.TNCVersion
        this.document = res.TNCFilename
        this.documentPure = res.TNCFilename
      }

      this.handlingViewTutorial(res)
    },
    handlingTncByEmployeeType (type) {
      if (type === 'EMPLOYEE' || type === 'PARTNER') {
        this.TNCPath = 'clinic/tnc'
      }
      return this.getPureDocument()
    },
    handlingViewTutorial (res) {
      if (this.TNCPath) {
        if (res.HasViewTutorial === null) {
          this.viewTutorial = true
        }
      }
    },
    getPureDocument () {
      let path = this.TNCPath || 'doctor/tnc'

      if (this.doctorType && this.doctorType === 'General Doctor') {
        path = 'doctor/tnc/general'
      }

      this.$store
        .dispatch('user/getPureDocument', path)
        .then((res) => {
          const date = this.$moment(res.data.Data.TNCUpdatedAt * 1000)
            .local()
            .format('DD MMMM YYYY')

          this.updatedDate = date
          this.documentPure = res.data.Data.TNCUrl
          this.TNCVersion = res.data.Data.Version
        })
        .catch((err) => {
          throw new Error(err)
        })
    },
    openGuideModal () {
      this.loading = true
      const data = {
        id: this.userId
      }
      let url = ''
      if (this.$store.state.user.auth.role === 'admin') {
        url = 'user/updateSKAdmin'
      } else {
        url = 'user/updateSK'
      }
      this.$store
        .dispatch(url, data)
        .then(() => {
          this.skModal = false
          this.guideModal = true
          this.checkHasViewTutorial()
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          throw new Error('error', error)
        })
    },
    openViewTutorial () {
      // TODO dynamic url video tutorial
      // this.urlVideoTutorial =
      this.guideModal = false
      this.viewTutorial = true
    },
    closeTutorial () {
      if (this.$store.state.user.auth.role !== 'admin') {
        this.$store
          .dispatch('calendar/sendTutorialComplete')
          .then((res) => {
            this.viewTutorial = false
            this.guideModal = false
            this.skDetailModal = false
            this.skModal = false
          })
          .catch((err) => {
            throw new Error(err)
          })
      } else {
        this.viewTutorial = false
        this.guideModal = false
        this.skDetailModal = false
        this.skModal = false
      }
    },
    goBack () {
      this.guideModal = true
      this.viewTutorial = false
      this.skModal = false
      this.skDetailModal = false
    },
    goToSK () {
      this.skDetailModal = true
      this.guideModal = false
      this.skModal = false
      this.viewTutorial = false
    }
  }
}
</script>

<style lang="scss">
.spinner-center {
  position: relative;
  height: 100%;

  .spinnerr {
    position: absolute;
    top: 50%;
    left: 50%;
  }
}

.modal-tutorial {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999999;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);

  .modal-tutorial-center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .terms-conditions-scroll {
    overflow-y: hidden;
    height: 80vh;
  }
}

/* The Close Button */
.close {
  //position: absolute;
  //top: -30px;
  //right: -40px;
  margin-top: -1.5rem;
  margin-right: -1.5rem;
  color: #ffffff;
  opacity: 1 !important;
  font-weight: bold;
  transition: 0.3s;
  //z-index: 999999;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.shadow-img {
  box-shadow: (0px 0px 16.5673px rgba(0, 0, 0, 0.25));
}

.btn-success-acc {
  background-color: #33b430 !important;
  color: #fff !important;
  padding: 0.5rem 10rem !important;
  font-family: "Rubik Medium", sans-serif !important;

  &.disabled,
  &:disabled {
    background-color: #b7b7b7 !important;
    color: #fff !important;

    &:hover {
      background-color: #b7b7b7 !important;
      color: #fff !important;
    }
  }
  &:hover,
  &:focus {
    background-color: #229d1f !important;
    color: #fff !important;
  }
}

.btn-green {
  background-color: #43a047 !important;
  color: #fff !important;
  border-radius: 8px !important;
  font-family: "Rubik Medium", sans-serif;

  &.btn-sk {
    box-shadow: inset 0px -5px 0px 0px #2d9508;
    border-radius: 3px !important;
    &:hover,
    &:focus {
      background-color: #2d9508 !important;
      color: #fff !important;
    }
  }

  &:hover,
  &:focus {
    background-color: #358839 !important;
    color: #fff !important;
  }
}

.btn-red {
  background-color: #fc3b3b !important;
  color: #fff !important;
  font-family: "Rubik Medium", sans-serif;
  border-radius: 8px !important;

  &:hover,
  &:focus {
    background-color: #e22929 !important;
    color: #fff !important;
  }
}

.modal-sk {
  .modal-header-sk {
    border-bottom: none;
    padding: 2rem 2rem 0;
    font-family: "Rubik Medium", sans-serif;
    color: #000;
    text-align: center;
    span {
      font-size: 25px;
    }
  }
  .modal-body-sk {
    padding: 1rem 2rem 2rem;
  }
  .body-modal {
    width: 100%;
    padding: 1rem;
    height: 440px;
    background-color: #f5f5f5;
    overflow-y: scroll;

    li {
      font-size: 1rem;
    }

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-button {
      width: 8px;
      height: 5px;
    }
    &::-webkit-scrollbar-track {
      background: #aeebff;
      border: thin solid lightgray;
      box-shadow: 0 0 3px #aeebff inset;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: #1d5779;
      border: thin solid gray;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #1d5779;
    }
  }

  ~ .modal-backdrop {
    opacity: 0.6;
  }
}

.modal-panduan {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999999;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);

  .modal-panduan-center {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @media screen and (min-width: 1200px) {
      width: 1200px;
    }
  }
}

.image-thumbnail {
  position: relative;

  .image-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.bg-grey {
  background-color: #e4e4e4;
}
.handle-title-data {
  font-weight: 500;
  font-size: 36px;
  line-height: 43px;
  text-align: center;
  color: #000000;
  margin-bottom: 20px;
}
.handle-pure-scroll {
  max-height: 60vh;
  overflow: scroll;
}
// ::-webkit-scrollbar {
//   -webkit-appearance: none;
//   width: 7px;
// }

// ::-webkit-scrollbar-thumb {
//   border-radius: 4px;
//   background-color: rgba(0, 0, 0, 0.5);
//   box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
//   height: 100px;
// }
</style>
